import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link,
  Alert,
  LinearProgress,
} from "@mui/material";
import { validatePasswordRecovery } from "../../services/Access";
import { t } from "i18next";

export default function PasswordRecovery(props) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResendEmailButton, setShowResendEmailButton] = useState(false);

  const handleClickCreateNewPassword = () => {
    if (password !== confirmPassword) {
      setError("As senhas não coincidem"); /*trad */
      return;
    }
    setLoading(true);

    validatePasswordRecovery({
      password,
      confirmPassword,
      code: props.passwordRecoveryCode,
    })
      .then(() => {
        document.location.href = "/?prs=1";
      })
      .catch((e) => {
        if (e.response?.data?.msg === "1") {
          setError("As senhas não coincidem"); /*trad */
        } else if (e.response?.data?.msg === "2") {
          setError(
            "A senha deve ter pelo menos 4 e no máximo 150 caracteres",
          ); /*trad */
        } else if (e.response?.data?.msg === "3") {
          setError(
            "A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um caractere especial e um número",
          ); /*trad */
        } else if (e.response?.data?.msg === "4") {
          setShowResendEmailButton(true);
          setError(
            "Código de recuperação inválido ou expirado. Clique no botão abaixo para gerar um novo",
          ); /*trad */
        } else {
          setError(
            "Erro ao criar nova senha. Tente novamente mais tarde.",
          ); /*trad */
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 400 }}>
        <Card elevation={3}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Typography variant="h6">{t("passwordRecovery")}</Typography>

              <Typography variant="body2">{t("createNewPassword")}</Typography>

              <TextField
                label={t("password")}
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClickCreateNewPassword();
                  }
                }}
              />

              <TextField
                label={t("confirmPassword")}
                type="password"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClickCreateNewPassword();
                  }
                }}
              />

              <Button
                variant="contained"
                fullWidth
                onClick={handleClickCreateNewPassword}
                disabled={showResendEmailButton || loading}
              >
                {t("createNewPassword")}
              </Button>

              {loading && (
                <Box sx={{ width: "100%" }}>
                  <LinearProgress />
                </Box>
              )}
              {error && (
                <Box sx={{ width: "100%" }}>
                  <Alert variant="outlined" severity="error">
                    {error}
                  </Alert>
                </Box>
              )}
              {showResendEmailButton && (
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => props.setFormType(3)}
                >
                  {t("generateNewCode")}
                </Button>
              )}
            </Box>
          </CardContent>
        </Card>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link
            href="#"
            underline="hover"
            onClick={() => (window.location.href = "/")}
          >
            <Typography variant="body2">{t("backToLogin")}</Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
